/**
 * Upload Schema — V2 Spend Plans
 *
 * Maps to SchemaV2SpendPlanPost in bldt-ui-fn/v2SpendPlans/schemas.ts
 * POST required: accountId, projectId, name, dateStart, dateEnd, currency
 *
 * Note: activityAllocations and contractAllocations are complex sub-objects
 * that are handled post-upload via a separate allocation step, not columns.
 */

import { UploadSchema } from '../types';

export const v2SpendPlanSchema: UploadSchema = {
	entityType: 'v2SpendPlan',
	label: 'Spend Plans',
	apiEndpoint: '/v2/spend-plans',
	customFieldEntityType: 'spend_plan',
	apiMethod: 'POST',
	fields: [
		{
			name: 'name',
			label: 'Spend Plan Name',
			dataType: 'string',
			required: true,
			constraints: { minLength: 1, maxLength: 255 },
			headerAliases: ['Spend Plan', 'SP Name', 'Plan Name', 'Title'],
		},
		{
			name: 'workPlanId',
			label: 'Work Plan',
			dataType: 'relation',
			required: true,
			relation: {
				entityType: 'workPlan',
				matchField: 'name',
				idField: 'id',
				contextKey: 'workPlans',
			},
			headerAliases: ['Work Plan Name', 'WP', 'Work Plan ID'],
		},
		{
			name: 'accountId',
			label: 'Account',
			dataType: 'relation',
			required: true,
			relation: {
				entityType: 'account',
				matchField: 'name',
				idField: 'id',
				contextKey: 'accounts',
				alternateMatchFields: ['accountNumber'],
			},
			headerAliases: ['Account Name', 'Designated Account', 'DA', 'Bank Account'],
		},
		{
			name: 'currency',
			label: 'Currency',
			dataType: 'string',
			required: true,
			constraints: { minLength: 3, maxLength: 3 },
			defaultValue: 'USD',
			headerAliases: ['Currency Code', 'Ccy'],
		},
		{
			name: 'dateStart',
			label: 'Start Date',
			dataType: 'date',
			required: true,
			headerAliases: ['Start', 'From Date', 'Period Start'],
		},
		{
			name: 'dateEnd',
			label: 'End Date',
			dataType: 'date',
			required: true,
			headerAliases: ['End', 'To Date', 'Period End'],
		},
	],
};
